import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { APP_VALIDATION_REGEX } from 'src/app/app.contant';
import { AuthService } from 'src/app/modules/core/services/auth/auth.service';
import { IAPIResponse, RoleEnum } from 'src/app/modules/shared/models';
import { AdminMasterEnum, IItracerRequest, IITracerUser, IUser, UserRoleType, USER_RULES } from '../../models';
import { existingItracerUserValidator } from '../../services/admin-helper.service';
import { AdminService } from '../../services/admin.service';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { TagInputComponent as SourceTagInput } from 'ngx-chips';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss']
})
export class UserDetailsComponent implements OnInit {

  public title !: string;
  public user !: IUser | null;
  public userActionType : "CREATE" | "UPDATE" |"COPY" = "CREATE";
  public userForm !: FormGroup;
  public masterData !: Record<AdminMasterEnum | string, string[]>
  public onClose = new Subject<any>();

  public USER_RULES : UserRoleType = USER_RULES;
  public _subscriptions : Subscription[] = []; 
  public enableModuleAccess !: boolean;
  public accessList :any = [];


  public isValidItracerUser : boolean = true;
  public itracerUserData!: IITracerUser;
  public purchase_group!:any;
  public selectedGroupName!:any;
  public enable_p_group_filter!:any;

  public mySettings: IMultiSelectSettings = {
    checkedStyle: 'fontawesome',
    buttonClasses: 'btn border-secondary form-control m-2',
    dynamicTitleMaxItems: 3,
    showCheckAll: true,
    showUncheckAll: true,
    displayAllSelectedText: true
  };
 
  public myTexts: IMultiSelectTexts = {
    defaultTitle: 'Select ESN Code'
  };

  public ESNList: IMultiSelectOption[] = [];
  currency: any;

  constructor(public bsModalRef: BsModalRef,
    private _adminService : AdminService,
    private _authService : AuthService,
    private _toastr : ToastrService,
    private _fb : FormBuilder) { }

  ngOnInit(): void {
    this._adminService.getCurrency().subscribe((res:any)=>{
      this.currency = res.data;
    })
    this.createForm();
    this.ESNList = this.masterData['ESN'].map((esn:any)=> {return {id:esn,name:esn}});
    if (this.user && this.userActionType !== "CREATE") {
      const updatedUser = this.getParsedUserInfo(JSON.parse(JSON.stringify(this.user)));
      this.patchForm(updatedUser);
      this.purchase_group = updatedUser.purchase_group;
      if (this.userActionType === 'UPDATE') {
        this.userForm.controls["gid"].disable();
        this.userForm.controls["role"].disable();
        this.userForm.controls["user_name"].disable();
        // this.userForm.controls["user_email"].disable();
        this.userForm.controls["domain"].disable();
      }
    }
    this.user && this.userActionType === "CREATE" && this.addDynamicValidations();
    this.userForm.controls['user_email'].valueChanges.subscribe((gid: string) => {
      const domain = this.userForm.controls['domain'].value;
      const itracerReq: IItracerRequest = { "username": gid, "role": "SiemensUser", "domain": domain };
      if (!this.isValidItracerUser) {

        this._adminService.getItacerUser({ ...itracerReq, ...{ "user_email": this.userForm.controls["user_email"].value } }).subscribe(({ data: iTracerUsers }: IAPIResponse<IITracerUser[]>) => {
          if (iTracerUsers?.length) {
            this.patchFormFields(iTracerUsers[0]);
            this.itracerUserData = iTracerUsers[0]
            this.isValidItracerUser = true;
          }
          if (!iTracerUsers.length) this.isValidItracerUser = false;
        },
          (err) => {
            this.isValidItracerUser = false
          })
      }
    });
    this.addItracerUserValidation();
  }

  private addItracerUserValidation() : void {
    
    this._subscriptions.push(
      this.userForm.controls['gid'].valueChanges.subscribe((gid : string) => {
        const domain = this.userForm.controls['domain'].value;
        const itracerReq : IItracerRequest = { "username": gid, "role":"SiemensUser", "domain": domain };
        this._adminService.getItacerUser(itracerReq).subscribe(({ data : iTracerUsers } : IAPIResponse<IITracerUser[]>) => {
          if(iTracerUsers?.length) {
            this.patchFormFields(iTracerUsers[0]);
            this.itracerUserData = iTracerUsers[0];
            this.isValidItracerUser = true;
          } 
          if(!iTracerUsers.length) this.isValidItracerUser = false;
        },
        (err) => {
          this.isValidItracerUser = false
        })
      })
    )
  }

  public patchFormFields = (iTracerUser : IITracerUser) => {
    this.userForm.controls["user_email"].patchValue(iTracerUser.email_id);
    this.userForm.controls["manager_gid"].patchValue(iTracerUser.manager_gid);
    this.userForm.controls["mobile_no"].patchValue(iTracerUser.mobile);
    this.userForm.controls["user_name"].patchValue(iTracerUser.name);
    // this.userForm.controls["user_email"].disable();
    this.userForm.controls["user_name"].disable();
    this.userForm.controls["domain"].disable();
  }

  private addDynamicValidations() : void {
    this._subscriptions.push(
      this.userForm.controls['role'].valueChanges.subscribe((userRole : RoleEnum) => {
        if(userRole) {
          if(userRole === RoleEnum.BUYER) {
            this.userForm.controls["currency"].addValidators([Validators.required]);
            this.userForm.controls["netprice_start"].addValidators([Validators.required, Validators.pattern(APP_VALIDATION_REGEX['ONLY_NUMBER_PATTERN'])]);
            this.userForm.controls["netprice_end"].addValidators([Validators.required, Validators.pattern(APP_VALIDATION_REGEX['ONLY_NUMBER_PATTERN'])]);
            this.userForm.controls["commodity"].addValidators([Validators.required]);
            this.userForm.controls["direct_indirect"].addValidators([Validators.required]);
            this.userForm.controls["esn"].addValidators([Validators.required]);
            this.userForm.controls["p_org"].removeValidators([Validators.required]);
            this.userForm.controls["enable_p_group_filter"].addValidators([Validators.required]);
          } else  if(userRole === RoleEnum.FACTORY_PROCUREMENT) { 
            this.userForm.controls["p_org"].addValidators([Validators.required]);
          } else{
            this.userForm.controls["currency"].removeValidators([Validators.required]);
            this.userForm.controls["netprice_start"].removeValidators([Validators.required, Validators.pattern(APP_VALIDATION_REGEX['ONLY_NUMBER_PATTERN'])]);
            this.userForm.controls["netprice_end"].removeValidators([Validators.required, Validators.pattern(APP_VALIDATION_REGEX['ONLY_NUMBER_PATTERN'])]);
            this.userForm.controls["commodity"].removeValidators([Validators.required]);
            this.userForm.controls["direct_indirect"].removeValidators([Validators.required]);
            this.userForm.controls["esn"].removeValidators([Validators.required]);
            this.userForm.controls["p_org"].removeValidators([Validators.required]);
            this.userForm.controls["enable_p_group_filter"].removeValidators([Validators.required]);
          }
          this.userForm.updateValueAndValidity();
        }
      })
    );
  }

  private getParsedUserInfo(user: any) : any {
    Object.keys(user).forEach((x : string) => {
      if(!this.USER_RULES.company_code[user.role] && (x === "company_code")) user[x] = user[x].toString();
      if(!this.USER_RULES.esn[user.role] && (x === "esn")) user[x] = user[x].toString();
      if(!this.USER_RULES.division[user.role] && (x === "division")) user[x] = user[x].toString();
    });
    return user
  }

  private patchForm(user : IUser) : void {
    user && this.userForm.patchValue(user);
  }

  private createForm() : void {
    this.userForm = this._fb.group({
      division : [[], Validators.required],
      company_code : [[], Validators.required],
      plant_code : [[], Validators.required],
      esn : [[]],
      location : ["", Validators.required],
      user_name : ["", Validators.required],
      domain:[null,Validators.required,],
      gid : ["", { 
        validators: [Validators.required], 
        // asyncValidators: [ existingItracerUserValidator(this._adminService) ],
        updateOn: "blur" 
      }],
      manager_gid:["",[Validators.required]],      
      user_email : ["", [Validators.required, , Validators.pattern(APP_VALIDATION_REGEX['EMAIL_PATTERN'])]],
      netprice_start : [""],
      netprice_end : [""],
      currency : [""],
      direct_indirect : [""],
      commodity : [""],
      role : [null, Validators.required],
      accessType :[null,Validators.required],
      accessList :[],
      active : [true, Validators.required],
      user_id : [null],
      mobile_no:[, Validators.required],
      p_org:[null],
      purchase_group:[null],
      enable_p_group_filter:[false]
    });
  }

  public updateInfo() : void {
    let userInfo = this.userForm.getRawValue();

    if (this.purchase_group?.map((purchase_groups:any)=> purchase_groups.value?purchase_groups.value:purchase_groups) == this.purchase_group?.map((purchase_groups:any)=> purchase_groups.value?purchase_groups.value.toUpperCase():purchase_groups)){
      this.selectedGroupName = this.purchase_group?.map((purchase_groups:any)=> purchase_groups.value?purchase_groups.value:purchase_groups)
    }else{
      this.selectedGroupName = this.purchase_group?.map((purchase_groups:any)=> purchase_groups.value?purchase_groups.value.toUpperCase():purchase_groups);
    }

    this.userForm.markAllAsTouched();
    ["company_code", "plant_code", "division", "esn"].forEach((x : string) => {
      if(typeof userInfo[x] === "string") {
        if(userInfo[x]) userInfo[x] = [userInfo[x]];
         else userInfo[x] = [];
      }
    });
    userInfo.department = this.itracerUserData?.department?this.itracerUserData?.department:this.user?.department?this.user?.department:"";;
    // userInfo.manager_gid = this.itracerUserData?.manager_gid?this.itracerUserData?.manager_gid:this.user?.manager_gid;
    userInfo.purchase_group = this.selectedGroupName;
    if(this.userActionType === 'COPY'){
      userInfo?.user_id ? userInfo.user_id = '' : '';
    }else{
      userInfo.user_id = this.user?.id;
    }
    let enableUpdate = true;
    if(userInfo?.enable_p_group_filter && userInfo.purchase_group.length == 0 && userInfo.role == 'BUYER'){
      this._toastr.error("Please Provide Purchase Group");
      enableUpdate = false;
    }
    const payload = { users : [userInfo] };
    if(enableUpdate){
      const apiUpdate$ = (this.userActionType === "CREATE" || this.userActionType === "COPY") ? this._adminService.createUser(payload) : this._adminService.updateUser(payload);
    apiUpdate$.subscribe((res : any) => {
      this._toastr.success("Saved Successfully!");
      this.closeModal(true);
    }, (err: any) => {
      this._toastr.error(err.error.message);
    });
    }
  }

  public onModalClose(): void {
    this.bsModalRef.hide();
  }

  public closeModal(data ?: any) {
    this.onClose.next(data);
    this._subscriptions.forEach(x=>x.unsubscribe());
    this.bsModalRef.hide();
  }

  ngOnDestoy() : void {
    this._subscriptions.forEach(x=>x.unsubscribe());
  }

  public onAccessChange(){
    if(this.userForm.controls["accessType"].value !== 'FULL' && this.userForm.controls["role"].value ){
      this.enableModuleAccess = true
      if(this.userForm.controls["role"].value == 'BUYER'){
        this.accessList = ['RFQ', 'QES']
      } else if(this.userForm.controls["role"].value == 'PO_BUYER'){
        this.accessList = [ 'PO', 'CONFIRMATION&DELIVERY']
      } else if(this.userForm.controls["role"].value == 'REQUESTOR'){
        this.accessList = [ 'PR']
      }else if(this.userForm.controls["role"].value == 'REPORTING_MANAGER'){
        this.accessList = [ 'PR']
      }else if(this.userForm.controls["role"].value == 'ADMIN'){
        this.accessList = [ 'USERMANAGEMENT']
      }else if(this.userForm.controls["role"].value == 'SUPPLIER'){
        this.accessList = [ 'RFQ']
      }else if(this.userForm.controls["role"].value == 'FACTORY_PROCUREMENT'){
        this.accessList = [ 'RFQ']
      }else if(this.userForm.controls["role"].value == 'QES_APPROVER'){
        this.accessList = [ 'QES']
      }
    }else{
      this.accessList = [ 'FULL']
    }
  }


}